import {yascDisplayName, yascTableIndex} from '@yasc/yasc-material-components';

export class ContactPersonDetailRes {
    id!: number

    @yascDisplayName('general_title')
    @yascTableIndex(1)
    title!: string;

    @yascDisplayName('general_salutation')
    @yascTableIndex(0)
    salutations!: number;

    @yascDisplayName('general_firstName')
    @yascTableIndex(2)
    firstName!: string;

    @yascDisplayName('general_lastName')
    @yascTableIndex(3)
    lastName!: string;

    @yascDisplayName('general_email')
    @yascTableIndex(4)
    email!: string;

    @yascDisplayName('general_phone')
    @yascTableIndex(5)
    phone!: string;

    @yascDisplayName('general_mobile')
    @yascTableIndex(6)
    mobile!: string;

    @yascDisplayName('general_department')
    department!: string;

    @yascDisplayName('general_company')
    @yascTableIndex(7)
    companyId!: number;
}


export class ContactPersonCreateReq {
    title: string = "";
    firstName: string = "";
    lastName: string = "";
    salutation: number = 0;
    email: string = "";
    phone: string = "";
    mobile: string = "";
    department: string = "";
    companyName: string = "";
    companyId!: number

    get salutations(): number {
        return this.salutation;
    }

    set salutations(value: number) {
        this.salutation = value;
    }

    constructor(contact?: ContactPersonDetailRes) {
        if (contact == undefined) return;
        this.firstName = contact.firstName;
        this.title = contact.title;
        this.lastName = contact.lastName;
        this.salutation = contact.salutations ?? (contact as any).salutation ?? 0;
        this.email = contact.email;
        this.phone = contact.phone
        this.mobile = contact.mobile;
        this.department = contact.department;
        this.companyId = contact.companyId;
    }
}

export class ContactPersonUpdateReq extends ContactPersonCreateReq {
    id?: number

    constructor(contact?: ContactPersonDetailRes) {
        super(contact);
        this.id = contact?.id
    }
}